// Shared config for the admin operations center (Spanish-only internal tool)
export const STATUSES = {
  pending_payment: { label: "Pendiente de pago", color: "#C4A661" },
  payment_received: { label: "Pago recibido", color: "#5FB4A2" },
  confirmed: { label: "Confirmada", color: "#139090" },
  in_operation: { label: "En operación", color: "#6FA8DC" },
  completed: { label: "Completada", color: "#7BC47F" },
  cancelled: { label: "Cancelada", color: "#8B8778" },
};

export const EXTRA_LABELS = {
  drone_video: "Video con drone",
  photo_package: "Paquete fotográfico",
};

export const PAYMENT_METHODS = ["efectivo", "transferencia", "tarjeta", "otro"];

export const TEAM_ROLES = [
  { key: "guia", label: "Guía" },
  { key: "fotografo", label: "Fotógrafo" },
  { key: "transporte", label: "Transporte" },
  { key: "otro", label: "Otro" },
];

export const fmtMxn = (n) => `MX$${(n || 0).toLocaleString()}`;

export const statusOf = (b) => STATUSES[b?.status] || STATUSES.pending_payment;

export function StatusBadge({ status }) {
  const s = STATUSES[status] || STATUSES.pending_payment;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] tracking-[0.14em] uppercase border whitespace-nowrap"
      style={{ color: s.color, borderColor: `${s.color}55` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}

export const inputCls =
  "w-full bg-transparent border border-[#1E2B25] focus:border-[#C4A661] outline-none px-3 py-2.5 text-sm text-[#F5F2EA] placeholder-[#5A5A50]";
